import * as THREE from "three";

function disposeHighlightOverlay(mesh) {
  const overlay = mesh?.userData?.highlightOverlay;
  if (!overlay) return;

  mesh.remove(overlay);
  if (overlay.geometry && overlay.geometry !== mesh.geometry) {
    overlay.geometry.dispose();
  }
  overlay.material?.dispose();
  mesh.userData.highlightOverlay = null;
}

export function addHighlightOverlay(mesh) {
  if (mesh?.userData?.isHighlightOverlay) return;
  disposeHighlightOverlay(mesh);
  if (!mesh?.geometry) return;

  const materialOptions = {
    color: 0x4893f4,
    transparent: true,
    opacity: 0.4,
    depthTest: false,
  };
  const overlay = mesh.isLine
    ? new THREE.Line(
        mesh.geometry,
        new THREE.LineBasicMaterial({
          ...materialOptions,
          linewidth: Math.max(Number(mesh.material?.linewidth) || 1, 3),
        })
      )
    : new THREE.Mesh(mesh.geometry, new THREE.MeshBasicMaterial(materialOptions));
  overlay.userData.isHighlightOverlay = true;
  overlay.renderOrder = 999;
  mesh.add(overlay);
  mesh.userData.highlightOverlay = overlay;
}

export function removeHighlightOverlay(mesh) {
  disposeHighlightOverlay(mesh);
}
